const apiKey = '56d5f4d99162dcffe5af5c6aba5c6fe2';

export default apiKey;


/** WEBPACK FOOTER **
 ** ./src/config/apikey.js
 **/